import { useEffect, useState, useContext, useRef} from 'react'
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import './css/thanks.css'

import Popup from "../components/Popup";
import { AppContext } from "../../Context";
import Fetch, { Loader, dateToText, user_login } from "../inc/Fetch";


import thanks from '../assets/thanks.png'

export default function Thanks() {
	
	const { t } = useTranslation();
	let navigate = useNavigate();
	const location = useLocation();

	const {siteData, successData, user} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;
	const [success, setsuccess] = successData;
	const [userinfo, setuserinfo] = user;


	const [loader, setloader] = useState(false);
	const [values, setvalues] = useState({});

	return (
		<>
			{loader && <Loader />}
			<Popup 
			
				className="thanksBox"
			>

				<img src={thanks} />
				<div className='thanksTextBody'>

					<h1>{t("thanks_title")}</h1>
					<p>{t("thanks_sub")}</p>
					
					<div>
						<span>{t("thanks_order_id")}: </span> 
						<b>{location?.state?.order?.ID}</b>

					</div>

				</div>
			</Popup>
			
		</>
	)
}
